import React from 'react';
import PageLayout from '../../components/PageLayout';
import CategoriesToolbar from './CategoriesToolbar';
import CategoriesList from './CategoriesList';
import CategoriesDetails from './CategoriesDetails';
import CategoriesPlaceholder from './CategoriesPlaceholder';
import { useSelector, useDispatch } from 'react-redux';
import { StoreState } from '../../store';
import { getCategories } from '../../store/categories/categoriesActions';
import { CategoriesActionTypes } from '../../store/categories/categoriesTypes';

export default function Categories() {
  const dispatch = useDispatch();
  const {
    isEditing,
    selectedIndex,
  } = useSelector((state: StoreState) => ({
    isEditing: state.categoriesState.isEditing,
    selectedIndex: state.categoriesState.selectedIndex,
  }));

  const onMountPage = () => dispatch( getCategories() );
  const onUnmountPage = () => dispatch({ type: CategoriesActionTypes.CLEAR });

  return (
    <PageLayout
      toolbar={<CategoriesToolbar />}
      list={<CategoriesList />}
      details={<CategoriesDetails key={String(selectedIndex)} />}
      detailsPlaceholder={<CategoriesPlaceholder />}
      hideDetails={!isEditing}
      onMountPage={onMountPage}
      onUnmountPage={onUnmountPage}
    />
  );
}
